module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN200_1862196716.9c75f1d0.png";